import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=2a11ae40&scoped=true&"
import script from "./Compliance.vue?vue&type=script&lang=js&"
export * from "./Compliance.vue?vue&type=script&lang=js&"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=2a11ae40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a11ae40",
  null
  
)

export default component.exports